<template>
    <v-dialog width="600px" :value="value" @input="toggleModal" scrollable >
        <v-card class="error">
            <v-card-text>
                <v-row>
                    <v-col class="text-center py-4" cols="12" >
                        <v-icon color="white" size="50">warning</v-icon>
                    </v-col>
                    <v-col cols="12" class="white--text text-center">
                        <h4>
                            {{ $t('general.doYouWantToDeleteProductsCategory') }}
                        </h4>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="white" text @click="toggleModal(false)">{{ $t('general.cancel') }}</v-btn>
                <v-btn outlined color="white" @click="submit" :loading="deletingUser">{{ $t('general.deleteProductsCategory') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
export default {
  data () {
    return {
      deletingUser: false
    }
  },
  methods: {
    async submit () {
      try {
        this.deletingUser = true
        const response = await this.$store.dispatch('deleteProductsCategory')
        this.deletingUser = false
        if (response.success) {
          notifications.success(response.message)
          this.$store.dispatch('getProductsCategories')
          this.toggleModal(false)
        } else if (response.message) {
          notifications.error(response.message)
        }
      } catch (error) {
        this.deletingUser = false
        notifications.error(error.message)
        console.error(error)
      }
    },
    toggleModal (value) {
      this.$emit('input', value)
    }
  },
  props: ['value']
}
</script>
